export default __webpack_public_path__ + "static/media/curved14.12c9ea54.jpg";